export const EVENT_NEXT_STEP = 'next-step';
export const EVENT_PREV_STEP = 'prev-step';
export const EVENT_SET_PROGRESS = 'set-progress';
export const EVENT_SET_SCENARIO = 'set-scenario';
export const EVENT_RESET_STEP = 'reset-step';
export const EVENT_DEMO_LINK = 'demo-link';
export const EVENT_LOG = 'log';
export const EVENT_ACTION_LOG = 'action-log';
export const EVENT_GA_SEND = 'ga-send';
export const EVENT_SET_STEP = 'event-set-step';
export const EVENT_NDC_APP_TAB_CLICK = 'event-ndc-app-tab-click';
export const EVENT_NDC_APP_SUBTAB_CLICK = 'event-ndc-app-subtab-click';
export const EVENT_NDC_APP_MENU_CLICK = 'event-ndc-app-menu-click';
export const EVENT_NDC_APP_SUBMENU_CLICK = 'event-ndc-app-submenu-click';
export const EVENT_NDC_APP_SOURCE_FILTER_CLICK = 'event-ndc-app-source-filter-click';
export const EVENT_CHECK_INPUT_VALUE = 'event-check-input-value';
export const EVENT_INFO_ICON_CLICK = 'event-info-icon-click';
export const EVENT_UI_BUTTON_CLICK = 'event-ui-button-click';
export const EVENT_UI_LINK_CLICK = 'event-ui-link-click';
export const EVENT_WORKFLOW_ACTION_CLICK = 'event-workflow-action-click';
export const EVENT_NDC_APP_SHOW_NOTIFICATION = 'event-ndc-app-show-notification';
export const EVENT_NDC_APP_HIDE_NOTIFICATION = 'event-ndc-app-hide-notification';
export const EVENT_ACTION_DONE = 'event-action-done';
export const EVENT_OPEN_TABS_DROPDOWN = 'event-open-tabs-dropdown';
export const EVENT_NDC_APP_RESET_RADIOBUTTONS = 'event-ndc-app-reset-radiobuttons';
export const EVENT_SET_GROUP_BY_RADIOBUTTON = 'event-set-group-by-radiobutton';
export const EVENT_SET_TAXONOMY_DROPDOWN = 'event-set-taxonomy-dropdown';
export const EVENT_SET_WORKFLOW_NAME = 'event-set-workflow-name';
export const EVENT_SET_REPOSITORY_TYPE = 'event-set-repository-type';
export const EVENT_SET_DESTINATION_VALUE = 'event-set-destination-value';
export const EVENT_SET_REPLICATE_VALUE = 'event-set-replicate-value';
export const EVENT_SET_COPY_OR_MOVE_VALUE = 'event-set-copy-or-move-value';
export const EVENT_SET_EXISTS_ACTION_VALUE = 'event-set-exists-action-value';
export const EVENT_EXPLAINER_DONE = 'event-explainer-done';
export const EVENT_EXPLAINER_SHOW = 'event-explainer-show';

export const EVENT_STA_SOLUTION_CLICK = 'event-sta-solution-click';
export const EVENT_STA_FILE_SYSTEM_LINK_CLICK = 'event-sta-file-system-link-click';
export const EVENT_STA_MAIN_MENU_CLICK = 'event-sta-main-menu-click';
export const EVENT_STA_RESOURCE_REVIEW_ITEM_CLICK = 'event-sta-resource-review-item-click';
export const EVENT_STA_CREATE_REVIEW_BUTTON_CLICK = 'event-sta-create-review-button-click';
export const EVENT_SENSITIVE_DATA_REPORT_CLICK = 'event-sensitive-data-report-click';
export const EVENT_PLUS_ICON_CLICK = 'event-plus-icon-click';
export const EVENT_STA_COMMON_ACTION = 'event-sta-common-action';

export const STA_SOLUTION_ITEM = 'sta-solution-item';
export const STA_FILE_SYSTEM_LINK = 'sta-file-system-link';
export const STA_SENSITIVE_DATA_REPORT = 'sta-sensitive-data-report';
export const STA_PLUS_ICON = 'sta-plus-icon';
export const STA_MAIN_MENU_ITEM = 'sta-main-menu-item';
export const STA_RESOURCE_REVIEW_ITEM = 'resource-review-item-item';
export const STA_CREATE_REVIEW_BUTTON = 'create-review-button-item';

export const TAB_SCREEN_DASHBOARD = 'dashboard';
export const TAB_SCREEN_CONTENT_DISTRIBUTION = 'content-distribution';
export const TAB_SCREEN_NEAR_DUPLICATE_DETECTION = 'near-duplicate-detection';

export const TAB_DASHBOARD = 'tab-new-dashboard';
export const TAB_CONTENT_DISTRIBUTION = 'tab-content-distribution';
export const TAB_DOCUMENT_REPORTS = 'tab-document-reports';
export const TAB_NEAR_DUPLICATE_DETECTION = 'tab-near-duplicate-detection';

export const TAB_DROPDOWN_STATE_CLASSIFICATION_REPORTS = 0;
export const TAB_DROPDOWN_STATE_DOCUMENT_REPORTS = 1;
export const TAB_DROPDOWN_STATE_SYSTEM_REPORTS = 2;

export const SUBTAB_NEAR_DUPLICATE_DETECTION = 3;

export const MENU_TAXONOMIES = 1;
export const MENU_WORKFLOWS = 2;
export const MENU_REPORTS = 5;

export const MODAL_DIALOG_SOURCE_FILTER = 'modal-source-filter';
export const MODAL_DIALOG_INFORMATION = 'modal-information';
export const MODAL_DIALOG_ADD_WORKFLOW = 'modal-add-workflow';
export const MODAL_DIALOG_DETAILS = 'modal-details';
export const MODAL_DIALOG_ADD_REQUEST = 'modal-add-request';

export const CH_WORKFLOW_DIALOG_NEXT_BUTTON = 0;
export const CH_WORKFLOW_DIALOG_RADIOBUTTONS = 1;
export const CH_NEAR_DUPLICATE_DETECTION_TABLE_FRAME = 2;
export const CH_CONTENT_DISTRIBUTION_GENERATE = 3;
export const CH_CONTENT_DISTRIBUTION_TILES = 4;
export const CH_WORKFLOW_DIALOG_FIRST_INPUT = 5;
export const CH_WORKFLOW_DIALOG_SECOND_INPUT = 6;
export const CH_WORKFLOW_DIALOG_REPLICATE_RADIO = 7;
export const CH_WORKFLOW_DIALOG_COPY_MOVE_RADIO = 8;
export const CH_WORKFLOW_DIALOG_EXISTS_ACTION_RADIO = 9;

export const CONTENT_DISTRIBUTION_TILES_SCREEN_1 = 1;
export const CONTENT_DISTRIBUTION_TILES_SCREEN_2 = 2;
export const CONTENT_DISTRIBUTION_TILES_SCREEN_3 = 3;

export const TAB_ITEM = 'tab-item';
export const TERM_ITEM = 'term-item';
export const TERM_TAB_ITEM = 'term-tab-item';
export const SUBTAB_ITEM = 'subtab-item';
export const MENU_ITEM = 'menu-item';
export const WORKFLOW_ACTION_ITEM = 'workflow-action-item';
export const SOURCE_FILTER_ITEM = 'source-filter-item';
export const MODAL_ADD_BUTTON = 'modal-add-button';
export const SEARCH_BUTTON = 'search-button';
export const SUGGESTION_CHECKBOXES = 'suggestion-checkboxes';
export const SUGGEST_BUTTON = 'suggest-button';
export const MODAL_NEXT_BUTTON = 'modal-next-button';
export const MODAL_RADIO_BUTTON = 'modal-radio-button';
export const MODAL_CLOSE_ICON = 'modal-close-icon';
export const INPUT_FIELD = 'input-field';
export const INSERT_LINK = 'insert-link';
export const INFO_ICON = 'info-icon';
export const CALCULATE_ICON = 'calculate-icon';
export const CLUE_ROW = 'clue-row';

// App settings
export const GLOBAL_OFFSET = 53;

export const PAGE_URL_ENGLISH = '/product_online_demo.html';
export const PAGE_URL_FRENCH = '/product_online_demo.html';
export const PAGE_URL_DEUTSCH = '/product_online_demo.html';
export const PAGE_URL_ITALIANO = '/product_online_demo.html';
export const PAGE_URL_RUSSIAN = '/product_online_demo.html';

export const PAGE_NDC_URL_ENGLISH = '/netwrix_data_classification_online_demo.html';
export const PAGE_STA_URL_ENGLISH = '/data_access_governance_online_demo.html';

export const LANGUAGE_ENGLISH = 0;
export const LANGUAGE_FRENCH = 1;
export const LANGUAGE_DEUTSCH = 2;
export const LANGUAGE_ITALIANO = 3;
export const LANGUAGE_RUSSIAN = 4;
export const LANGUAGE_SPANISH = 5;
export const LANGUAGE_DEFAULT = LANGUAGE_ENGLISH;

export const WEB_DEMO_TYPE_NA = 0;
export const WEB_DEMO_TYPE_NDC = 1;
export const WEB_DEMO_TYPE_STA = 2;
export const WEB_DEMO_TYPE = WEB_DEMO_TYPE_NA;
